<template>
    <el-dialog v-model="dialogVisible" title="用户区域" width="700px" :before-close="handleClose">
        <div class="dia-content-box">
            <div class="lef-tree-box" v-show="arrowShow">
                <!-- <div class="guolv-box">
                    <el-input
                        placeholder="输入关键字进行过滤"
                        v-model="filterText">
                    </el-input>
                </div> -->
                <el-tree 
                    class="filter-tree" 
                    :data="userTrData" 
                    :props="defaultProps" 
                    node-key="id"
                    :default-expanded-keys="treeExpandedKeyList"
                    :filter-node-method="filterNode"
                    :render-content="renderContent"
                    @node-click="handleNodeClick" ref="tree">
                </el-tree>
                <!-- <el-tree 
                    :data="data" 
                    :props="defaultProps" 
                    @node-click="handleNodeClick"
                    @current-change='currentChange'
                    ref="tree"
                    >
                </el-tree> -->
            </div>
            <div class="rig-list-box">
                <!-- <div class="top-inp">
                    <ArrowLeft v-if="arrowShow" class="img-zhankai" @click="zhankai(1)"></ArrowLeft>
                    <ArrowRight v-else class="img-zhankai" @click="zhankai(2)"></ArrowRight>
                    <el-input v-model="inputValue" placeholder="请输入内容"></el-input>
                    <div class="top-button-box">
                        <el-button type="primary" @click='searchClick()'>查询</el-button>
                        <el-button type="success" @click="resettingClick()">重置</el-button>
                    </div>
                </div> -->
                
                <el-table border :data="tableData" style="width: 100%">
                    
                    <el-table-column type="index" label="编号" width="50">
                    </el-table-column>
                    <el-table-column prop="circleName" label="名称">
                        <template #default="scope">
                            {{ 
                                // scope
                                scope.row.alias ||
                                scope.row.siteName ||
                                scope.row.circleName ||
                                scope.row.username ||
                                scope.row.label 
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="操作" width="100">
                        <template #default="scope">
                            <el-button size="mini" type="" @click="handleDelete(scope.$index, scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
            </div>
        </div>
        <!-- <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogVisible = false">Cancel</el-button>
            <el-button type="primary" @click="dialogVisible = false">
            Confirm
            </el-button>
        </div>
        </template> -->
    </el-dialog>
</template>

<script>
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue"; // 图标
import {
    userTree,
    userList
} from '@/assets/api/api'
export default {
    components: {
        ArrowLeft,
        ArrowRight
    },
    data() {
        return {
            filterText: '',
            dialogVisible: true,
            userTrData: [],
            defaultProps: {
                children: 'children',
                label: 'username'
            },
            inputValue: '',
            tableData: [

            ],
            arrowShow: true,
            pageValue: 1,
            total: 0,
            userTrItem: {},
            treeExpandedKeyList: []
        };
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    created() {
        this.userTreeGet()
    },
    mounted() {

    },
    methods: {
        renderContent(h, { node, data }) {
            // 动态判断显示哪个字段
            let label = ''
            if ( data.alias && data.alias != '' ) {
                label = data.alias
            } else if ( label == '' && data.username && data.username != ''  ) {
                label = data.username
            }
            return h('span', label);
        },
        handleCurrentChange (val) {
            console.log(val,9999);
            this.pageValue = val
            this.userListPost()
        },
        userTreeGet() {
            const params = {
                userId: JSON.parse(localStorage.getItem('user')).id
            };
            userTree(params).then((res) => {
                console.log(res, 123456);
                this.userTrData = res.data.data
                this.treeExpandedKeyList = [res.data.data[0].id]
            }).catch((err) => {
                console.log(err);
            })
        },
        userListPost() {
            const params = {
                page: this.pageValue,
                pageSize: 30,
            };
            userList(params, this.userTrItem.id).then((res) => {
                console.log(res, '列表');
                this.tableData = res.data.data.list
                this.total = res.data.data.total
            }).catch((err) => {
                console.log(err);
            })
        },
        resettingClick() {
            console.log('重置');
            this.inputValue = ''
        },
        searchClick() {
            console.log('查询');
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        zhankai(val) {
            this.arrowShow = !this.arrowShow
        },
        handleDelete(index, row) {
            // console.log(index, row,'选择1111');
            // let item = 
            if ( row.alias) {
                row.name = row.alias
            }else if ( row.siteName && !row.name) {
                row.name = row.siteName
            } else if (row.circleName  && !row.name) {
                row.name = row.circleName
            } else if (row.username  && !row.name) {
                row.name = row.username
            } else if (row.label  && !row.name) {
                row.name = row.label
            }
            this.$emit('singleSelectionClick', row)
        },
        handleNodeClick(data, node,) {
            console.log(data, 66666);
            this.userTrItem = data
            this.pageValue = 1
            this.userListPost()
            // if (node.isLeaf) {
            //     // 是最后一个节点，执行你需要的操作
            //     console.log('最后一节点', data);
            // }
        },
        currentChange(val) {
            // console.log(val,9999);
        },
        handleClose() {
            //   console.log(45645);  
            this.$emit('handleClose')
        },
    },
};
</script>

<style scoped lang="scss">
.dia-content-box {
    display: flex;
    height: 400px;

    // justify-content: space-between;
    .lef-tree-box {
        flex: 35%;
        height: 100%;
        overflow: auto;
        background-color: #F3F3F3;

        .guolv-box {
            padding: 10px 6px;

            /deep/ {
                .el-input__inner {
                    height: 30px;
                    line-height: 30px;
                }
            }
        }

        /deep/ {
            .el-tree {
                background-color: #F3F3F3;
            }
        }
    }

    .tree-box-width {
        // width: 0px;
        flex: 0%;
    }

    .rig-list-box {
        flex: 65%;
        height: 100%;
        overflow: auto;
        padding-left: 10px;
        // padding-top: 10px;

        // background-color: seagreen
        .top-inp {
            display: flex;
            align-items: center;
            /* 垂直居中 */
            margin-bottom: 10px;

            .img-zhankai {
                // font-size: 12px ;
                width: 20px;
                cursor: pointer;
            }

            /deep/ {
                .el-input {
                    width: 45%;
                    height: 30px;
                    line-height: 30px;
                }
            }

            .top-button-box {
                margin-left: 10px;
            }
        }
        /deep/ {
            .el-table {
                height: 360px;
                overflow: auto;
            }
        }
    }
}
</style>
